module.exports = __webpack_public_path__ + "static/media/bgr-about-quote.f05c1e10.webp";